// extracted by mini-css-extract-plugin
export default {"chartBlock":"ChartBlock_chartBlock__vgRVV","chartTitle":"ChartBlock_chartTitle__bwwCD"};